export const SET_PREFIXES = 'RETRANSMISSION_PREFIX_SET_PREFIXES';
export const ADD_PREFIX = 'RETRANSMISSION_PREFIX_ADD';
export const UPDATE_PREFIX = 'RETRANSMISSION_PREFIX_UPDATE';
export const REMOVE_PREFIX = 'RETRANSMISSION_PREFIX_REMOVE';
export const SET_LOADING = 'RETRANSMISSION_PREFIX_SET_LOADING';
export const SET_ERROR = 'RETRANSMISSION_PREFIX_SET_ERROR';
export const SET_TRANSPORT_PREFIXES = 'RETRANSMISSION_PREFIX_SET_TRANSPORT_PREFIXES';
export function setPrefixes(prefixes) {
    return {
        type: SET_PREFIXES,
        payload: { prefixes },
    };
}
export function addPrefix(prefix) {
    return {
        type: ADD_PREFIX,
        payload: { prefix },
    };
}
export function updatePrefixAction(prefix) {
    return {
        type: UPDATE_PREFIX,
        payload: { prefix },
    };
}
export function removePrefix(id) {
    return {
        type: REMOVE_PREFIX,
        payload: { id },
    };
}
export function setLoading(isLoading) {
    return {
        type: SET_LOADING,
        payload: { isLoading },
    };
}
export function setError(error) {
    return {
        type: SET_ERROR,
        payload: { error },
    };
}
export function setTransportPrefixes(prefixes, transportId, groupId = null) {
    return {
        type: SET_TRANSPORT_PREFIXES,
        payload: { prefixes, transportId, groupId },
    };
}
